import { serverApi } from "./serverApi";
import { Environment } from "../types/environmentTypes";

export const environmentService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    getAllEnvironments: build.query<Array<Environment>, string>({
      query: () => ({
        url: "/environment/environments"
      })
    }),
    createEnvironment: build.mutation<number, Environment>({
      query: (environment) => ({
        url: "/environment/environment",
        method: "POST",
        body: environment
      })
    }),
    updateEnvironment: build.mutation<number, Environment>({
      query: (environment) => ({
        url: "/environment/environment",
        method: "PUT",
        body: environment
      })
    }),
    deleteEnvironment: build.mutation<void, number>({
      query: (environmentId) => ({
        url: "/environment/environment",
        method: "DELETE",
        params: {
          id: environmentId
        }
      })
    })
  })
});

export const {
  useGetAllEnvironmentsQuery,
  useCreateEnvironmentMutation,
  useUpdateEnvironmentMutation,
  useDeleteEnvironmentMutation
} = environmentService;